import { useContext, createContext } from "react";
import { Platform } from "react-native";

const defaultState = {
  enabled: false,
  setStatus: (status: boolean) => {},
};

export const ScrollContext = createContext(defaultState);

function useScrollLock() {
  let ctx = useContext(ScrollContext);

  return {
    enabled: ctx.enabled,
    disable: () => {
      ctx.setStatus(false);
      if (Platform.OS === "web") {
        document.body.classList.remove("scroll-lock");
      }
    },
    enable: () => {
      ctx.setStatus(true);
      if (Platform.OS === "web") {
        document.body.classList.add("scroll-lock");
      }
    },
  };
}

export default useScrollLock;
